export const FormPropertyTypes = {
  Radio: 0,
  Checkbox: 1,
  Textarea: 2,
  Textfield: 3,
  File: 4,
  Select: 5,
  Date: 6
}
export const QuestionFromObjMap = {
  Meta: {
    Title: 'Application Form',
    InternalTitle: 'Application Form',
    Description: 'Thank you for your interests in PwC You Plus Programme!\r\nApplications are accepted and evaluated on a rolling basis. To secure a seat for the coming intake, you are strongly recommended to apply right now!\r\nQualified candidates will be invited to attend a mandatory panel interview, and notification of admission decisions will be released after the interview.\r\nClick the &apos;Application Instructions&apos; button below and review the instructions and requirements in details.'
  },
  Pages: [
    {
      Title: 'Personal and contact details',
      Questions: [
        {
          name: 'LiveType',
          id: 'Q168P0001',
          type: FormPropertyTypes.Select,
          required: true,
          // width: '70%',
          label:
            'Are you a Chinese citizen or eligible to stay in China without visa sponorship?',
          options: [
            { id: 'Q168P0001o1', label: 'Yes 是' },
            { id: 'Q168P0001o2', label: 'No 否' }
          ]
        },
        {
          name: 'MandarinProficiencyLevel',
          id: 'Q168P0002',
          type: FormPropertyTypes.Select,
          required: true,
          half: true,
          label:
            'What is your mandarin proficiency level?',
          options: [
            { id: 'Q168P0002o1', label: 'Elementary 满足基础交流' },
            { id: 'Q168P0002o2', label: 'Business Proficiency 商务汉语流利' },
            { id: 'Q168P0002o3', label: 'Native or Biligual 母语或双语' }
          ]
        },
        {
          name: 'IDNumber',
          id: 'Q168P0003',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'ID number (eg. Passport, National ID)',
          options: [
          ]
        },
        {
          name: 'GivenName',
          id: 'Q168P0004',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'Given Name (Must be consistent with the name on your ID documents)',
          options: [
          ]
        },
        {
          name: 'GivenNameInChinese',
          id: 'Q168P0005',
          type: FormPropertyTypes.Textfield,
          required: false,
          half: true,
          label:
            'Given Name in Chinese (If applicable)',
          options: [
          ]
        },
        {
          name: 'FamilyName',
          id: 'Q168P0006',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'Family Name (Must be consistent with the name on your ID documents)',
          options: [
          ]
        },
        {
          name: 'FamilyNameInChinese',
          id: 'Q168P0007',
          type: FormPropertyTypes.Textfield,
          required: false,
          half: true,
          label:
            'Family Name in Chinese (If applicable)',
          options: [
          ]
        },
        {
          name: 'Birthday',
          id: 'Q168P0008',
          type: FormPropertyTypes.Date,
          required: true,
          half: true,
          label:
            'Date of birth',
          options: [
          ]
        },
        {
          name: 'SecondaryContactNumber',
          id: 'Q168P0009',
          type: FormPropertyTypes.Textfield,
          required: false,
          half: true,
          label:
            'Secondary Contact Number',
          options: [
          ]
        },
        {
          name: 'Gender',
          id: 'Q168P0010',
          type: FormPropertyTypes.Select,
          required: true,
          half: true,
          label:
            'Gender',
          options: [
            { id: 'Q168P0010o1', label: 'Prefer not to disclose 不愿意透露' },
            { id: 'Q168P0010o2', label: 'Male 男性' },
            { id: 'Q168P0010o3', label: 'Female 女性' }
          ]
        },
        {
          name: 'Email',
          id: 'Q168P0011',
          type: FormPropertyTypes.Textfield,
          required: true,
          dataType: 'email',
          half: true,
          label:
            'Email address',
          options: [
          ]
        }
      ]
    },
    {
      Title: 'Emergency contact',
      Questions: [
        {
          name: 'EmergencyContactName',
          id: 'Q168P0101',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'Name',
          options: [
          ]
        },
        {
          name: 'Relationship',
          id: 'Q168P0102',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'Relationship',
          options: [
          ]
        },
        {
          name: 'ContactNumber',
          id: 'Q168P0103',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'Contact number',
          options: [
          ]
        },
        {
          name: 'ContactEmailAddress',
          id: 'Q168P0104',
          type: FormPropertyTypes.Textfield,
          required: true,
          half: true,
          label:
            'Email address',
          options: [
          ]
        }
      ]
    },
    {
      Title: 'Educational history',
      Multiple: true,
      Questions: [
        [
          {
            name: 'FirstHighestEducationDegree',
            id: 'Q168P0201',
            type: FormPropertyTypes.Select,
            required: true,
            width: '50%',
            // half: true,
            label: 'Highest education degree (If other, please specify)',
            options: [
              { id: 'Q168P0201o1', label: 'Bachelor 本科' },
              { id: 'Q168P0201o2', label: 'Master 硕士' },
              { id: 'Q168P0201o3', label: 'PhD 博士' },
              { id: 'Q168P0201o4', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'FirstHighestEducationDegree_other',
            id: 'Q168P0201o4_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            // half: true,
            width: '50%',
            label: '',
            options: [
            ]
          },
          {
            name: 'FirstEducationalUniversity',
            id: 'Q168P0203',
            type: FormPropertyTypes.Textfield,
            required: true,
            width: '50%',
            // half: true,
            label: 'University or educational institution',
            options: [
            ]
          },
          {
            name: 'FirstEducationalFrom',
            id: 'Q168P0204',
            type: FormPropertyTypes.Date,
            required: true,
            half: true,
            label: 'From',
            options: [
            ]
          },
          {
            name: 'FirstEducationalTo',
            id: 'Q168P0205',
            type: FormPropertyTypes.Date,
            required: true,
            half: true,
            label: 'To',
            options: [
            ]
          },
          {
            name: 'FirstGPA',
            id: 'Q168P0206',
            type: FormPropertyTypes.Textfield,
            required: true,
            width: '50%',
            label: 'GPA',
            options: [
            ]
          },
          {
            name: 'FirstMajor',
            id: 'Q168P0207',
            type: FormPropertyTypes.Select,
            required: true,
            half: true,
            label: 'Major (If other, please specify)',
            options: [
              { id: 'Q168P0207o01', label: 'Accounting 会计' },
              { id: 'Q168P0207o02', label: 'Acturial 精算' },
              { id: 'Q168P0207o03', label: 'Business 商务' },
              { id: 'Q168P0207o04', label: 'Engineering 工程' },
              { id: 'Q168P0207o05', label: 'Law 法律' },
              { id: 'Q168P0207o06', label: 'Mathematics 数学' },
              { id: 'Q168P0207o07', label: 'Science 科学' },
              { id: 'Q168P0207o08', label: 'Technology 技术' },
              { id: 'Q168P0207o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'FirstMajor_other',
            id: 'Q168P0207o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            half: true,
            label: '',
            options: [
            ]
          },
          {
            name: 'FirstMinor',
            id: 'Q168P0209',
            type: FormPropertyTypes.Select,
            required: false,
            half: true,
            label: 'Minor (If other, please specify)',
            options: [
              { id: 'Q168P0209o01', label: 'Accounting 会计' },
              { id: 'Q168P0209o02', label: 'Acturial 精算' },
              { id: 'Q168P0209o03', label: 'Business 商务' },
              { id: 'Q168P0209o04', label: 'Engineering 工程' },
              { id: 'Q168P0209o05', label: 'Law 法律' },
              { id: 'Q168P0209o06', label: 'Mathematics 数学' },
              { id: 'Q168P0209o07', label: 'Science 科学' },
              { id: 'Q168P0209o08', label: 'Technology 技术' },
              { id: 'Q168P0209o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'FirstMinor_other',
            id: 'Q168P0209o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            half: true,
            label: '',
            options: [
            ]
          }
        ],
        [
          {
            name: 'SecondaryHighestEducationDegree',
            id: 'Q168P02012',
            type: FormPropertyTypes.Select,
            required: true,
            label: 'Secondary highest education degree (If other, please specify)',
            options: [
              { id: 'Q168P02012o1', label: 'Bachelor 本科' },
              { id: 'Q168P02012o2', label: 'Master 硕士' },
              { id: 'Q168P02012o3', label: 'PhD 博士' },
              { id: 'Q168P02012o4', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'SecondaryHighestEducationDegree_other',
            id: 'Q168P02012o4_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            name: 'SecondaryEducationalUniversity',
            id: 'Q168P02032',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'University or educational institution',
            options: [
            ]
          },
          {
            name: 'SecondaryEducationalFrom',
            id: 'Q168P02042',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'From',
            options: [
            ]
          },
          {
            name: 'SecondaryEducationalTo',
            id: 'Q168P02052',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'To',
            options: [
            ]
          },
          {
            name: 'SecondaryGPA',
            id: 'Q168P02062',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'GPA',
            options: [
            ]
          },
          {
            name: 'SecondaryMajor',
            id: 'Q168P02072',
            type: FormPropertyTypes.Select,
            required: true,
            label: 'Major (If other, please specify)',
            options: [
              { id: 'Q168P02072o01', label: 'Accounting 会计' },
              { id: 'Q168P02072o02', label: 'Acturial 精算' },
              { id: 'Q168P02072o03', label: 'Business 商务' },
              { id: 'Q168P02072o04', label: 'Engineering 工程' },
              { id: 'Q168P02072o05', label: 'Law 法律' },
              { id: 'Q168P02072o06', label: 'Mathematics 数学' },
              { id: 'Q168P02072o07', label: 'Science 科学' },
              { id: 'Q168P02072o08', label: 'Technology 技术' },
              { id: 'Q168P02072o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'SecondaryMajor_other',
            id: 'Q168P02072o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            name: 'SecondaryMinor',
            id: 'Q168P02092',
            type: FormPropertyTypes.Select,
            required: false,
            label: 'Minor (If other, please specify)',
            options: [
              { id: 'Q168P02092o01', label: 'Accounting 会计' },
              { id: 'Q168P02092o02', label: 'Acturial 精算' },
              { id: 'Q168P02092o03', label: 'Business 商务' },
              { id: 'Q168P02092o04', label: 'Engineering 工程' },
              { id: 'Q168P02092o05', label: 'Law 法律' },
              { id: 'Q168P02092o06', label: 'Mathematics 数学' },
              { id: 'Q168P02092o07', label: 'Science 科学' },
              { id: 'Q168P02092o08', label: 'Technology 技术' },
              { id: 'Q168P02092o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'SecondaryMinor',
            id: 'Q168P02092o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          }
        ],
        [
          {
            name: 'ThirdHighestEducationDegree',
            id: 'Q168P02013',
            type: FormPropertyTypes.Radio,
            required: true,
            label: 'Third highest education degree (If other, please specify)',
            options: [
              { id: 'Q168P02013o1', label: 'Bachelor 本科' },
              { id: 'Q168P02013o2', label: 'Master 硕士' },
              { id: 'Q168P02013o3', label: 'PhD 博士' },
              { id: 'Q168P02013o4', label: 'Others, please specify 其他，请注明' }
            ]
          },
          { name: 'ThirdHighestEducationDegree_other',
            id: 'Q168P02013o4_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            name: 'ThirdEducationalUniversity',
            id: 'Q168P02033',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'University or educational institution',
            options: [
            ]
          },
          {
            name: 'Q168P02043',
            id: 'Q168P02043',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'From',
            options: [
            ]
          },
          {
            name: 'Q168P02053',
            id: 'Q168P02053',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'To',
            options: [
            ]
          },
          {
            name: 'Q168P02063',
            id: 'Q168P02063',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'GPA',
            options: [
            ]
          },
          {
            id: 'Q168P02073',
            name: 'Q168P02073',
            type: FormPropertyTypes.Select,
            required: true,
            label: 'Major (If other, please specify)',
            options: [
              { id: 'Q168P02073o01', label: 'Accounting 会计' },
              { id: 'Q168P02073o02', label: 'Acturial 精算' },
              { id: 'Q168P02073o03', label: 'Business 商务' },
              { id: 'Q168P02073o04', label: 'Engineering 工程' },
              { id: 'Q168P02073o05', label: 'Law 法律' },
              { id: 'Q168P02073o06', label: 'Mathematics 数学' },
              { id: 'Q168P02073o07', label: 'Science 科学' },
              { id: 'Q168P02073o08', label: 'Technology 技术' },
              { id: 'Q168P02073o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02073o09_other',
            name: 'Q168P02073o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            id: 'Q168P02093',
            name: 'Q168P02093',
            type: FormPropertyTypes.Select,
            required: false,
            label: 'Minor (If other, please specify)',
            options: [
              { id: 'Q168P02093o01', label: 'Accounting 会计' },
              { id: 'Q168P02093o02', label: 'Acturial 精算' },
              { id: 'Q168P02093o03', label: 'Business 商务' },
              { id: 'Q168P02093o04', label: 'Engineering 工程' },
              { id: 'Q168P02093o05', label: 'Law 法律' },
              { id: 'Q168P02093o06', label: 'Mathematics 数学' },
              { id: 'Q168P02093o07', label: 'Science 科学' },
              { id: 'Q168P02093o08', label: 'Technology 技术' },
              { id: 'Q168P02093o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02093o09_other',
            name: 'Q168P02093o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          }
        ],
        [
          {
            id: 'Q168P02014',
            name: 'Q168P02014',
            type: FormPropertyTypes.Radio,
            required: true,
            label: 'Fourth highest education degree (If other, please specify)',
            options: [
              { id: 'Q168P02014o1', label: 'Bachelor 本科' },
              { id: 'Q168P02014o2', label: 'Master 硕士' },
              { id: 'Q168P02014o3', label: 'PhD 博士' },
              { id: 'Q168P02014o4', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            name: 'Q168P02014o4_other',
            id: 'Q168P02014o4_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            name: 'Q168P02034',
            id: 'Q168P02034',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'University or educational institution',
            options: [
            ]
          },
          {
            name: 'Q168P02044',
            id: 'Q168P02044',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'From',
            options: [
            ]
          },
          {
            name: 'Q168P02054',
            id: 'Q168P02054',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'To',
            options: [
            ]
          },
          {
            id: 'Q168P02064',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'GPA',
            options: [
            ]
          },
          {
            id: 'Q168P02074',
            type: FormPropertyTypes.Select,
            required: true,
            label: 'Major (If other, please specify)',
            options: [
              { id: 'Q168P02074o01', label: 'Accounting 会计' },
              { id: 'Q168P02074o02', label: 'Acturial 精算' },
              { id: 'Q168P02074o03', label: 'Business 商务' },
              { id: 'Q168P02074o04', label: 'Engineering 工程' },
              { id: 'Q168P02074o05', label: 'Law 法律' },
              { id: 'Q168P02074o06', label: 'Mathematics 数学' },
              { id: 'Q168P02074o07', label: 'Science 科学' },
              { id: 'Q168P02074o08', label: 'Technology 技术' },
              { id: 'Q168P02074o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02074o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            id: 'Q168P02094',
            type: FormPropertyTypes.Select,
            required: false,
            label: 'Minor (If other, please specify)',
            options: [
              { id: 'Q168P02094o01', label: 'Accounting 会计' },
              { id: 'Q168P02094o02', label: 'Acturial 精算' },
              { id: 'Q168P02094o03', label: 'Business 商务' },
              { id: 'Q168P02094o04', label: 'Engineering 工程' },
              { id: 'Q168P02094o05', label: 'Law 法律' },
              { id: 'Q168P02094o06', label: 'Mathematics 数学' },
              { id: 'Q168P02094o07', label: 'Science 科学' },
              { id: 'Q168P02094o08', label: 'Technology 技术' },
              { id: 'Q168P02094o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02094o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          }
        ],
        [
          {
            id: 'Q168P02015',
            type: FormPropertyTypes.Radio,
            required: true,
            label: 'Fifth highest education degree (If other, please specify)',
            options: [
              { id: 'Q168P02015o1', label: 'Bachelor 本科' },
              { id: 'Q168P02015o2', label: 'Master 硕士' },
              { id: 'Q168P02015o3', label: 'PhD 博士' },
              { id: 'Q168P02015o4', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02015o4_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            id: 'Q168P02035',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'University or educational institution',
            options: [
            ]
          },
          {
            id: 'Q168P02045',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'From',
            options: [
            ]
          },
          {
            id: 'Q168P02055',
            type: FormPropertyTypes.Date,
            required: true,
            label: 'To',
            options: [
            ]
          },
          {
            id: 'Q168P02065',
            type: FormPropertyTypes.Textfield,
            required: true,
            label: 'GPA',
            options: [
            ]
          },
          {
            id: 'Q168P02075',
            type: FormPropertyTypes.Select,
            required: true,
            label: 'Major (If other, please specify)',
            options: [
              { id: 'Q168P02075o01', label: 'Accounting 会计' },
              { id: 'Q168P02075o02', label: 'Acturial 精算' },
              { id: 'Q168P02075o03', label: 'Business 商务' },
              { id: 'Q168P02075o04', label: 'Engineering 工程' },
              { id: 'Q168P02075o05', label: 'Law 法律' },
              { id: 'Q168P02075o06', label: 'Mathematics 数学' },
              { id: 'Q168P02075o07', label: 'Science 科学' },
              { id: 'Q168P02075o08', label: 'Technology 技术' },
              { id: 'Q168P02075o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02075o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          },
          {
            id: 'Q168P02095',
            type: FormPropertyTypes.Select,
            required: false,
            label: 'Minor (If other, please specify)',
            options: [
              { id: 'Q168P02095o01', label: 'Accounting 会计' },
              { id: 'Q168P02095o02', label: 'Acturial 精算' },
              { id: 'Q168P02095o03', label: 'Business 商务' },
              { id: 'Q168P02095o04', label: 'Engineering 工程' },
              { id: 'Q168P02095o05', label: 'Law 法律' },
              { id: 'Q168P02095o06', label: 'Mathematics 数学' },
              { id: 'Q168P02095o07', label: 'Science 科学' },
              { id: 'Q168P02095o08', label: 'Technology 技术' },
              { id: 'Q168P02095o09', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P02095o09_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label: '',
            options: [
            ]
          }
        ]
      ]
    },
    {
      Title: 'Awards and accomplishments'
    },
    {
      Title: 'Standardized tests'
    },
    {
      Title: 'English skills'
    },
    {
      Title: 'Other language skills'
    },
    {
      Title: 'Professional qualifications'
    },
    {
      Title: 'Work experience'
    },
    {
      Title: 'Open questions'
    },
    {
      Title: 'Recommendation'
    },
    {
      Title: 'Attachment'
    },
    {
      Title: 'More about you'
    }
  ]
}

export const QuestionFromMap = {
  Q168: {
    Title: 'Application Form',
    InternalTitle: 'Application Form',
    Description: 'Thank you for your interests in PwC You Plus Programme!\r\nApplications are accepted and evaluated on a rolling basis. To secure a seat for the coming intake, you are strongly recommended to apply right now!\r\nQualified candidates will be invited to attend a mandatory panel interview, and notification of admission decisions will be released after the interview.\r\nClick the &apos;Application Instructions&apos; button below and review the instructions and requirements in details.',
    P0: {
      Title: 'Personal and contact details',
      Questions: [
        {
          id: 'Q168P0001',
          type: FormPropertyTypes.Radio,
          required: true,
          label:
            'Are you a Chinese citizen or eligible to stay in China without visa sponorship?',
          options: [
            { id: 'Q168P0001o1', label: 'Yes 是' },
            { id: 'Q168P0001o2', label: 'No 否' }
          ]
        },
        {
          id: 'Q168P0002',
          type: FormPropertyTypes.Radio,
          required: true,
          label:
            'What is your mandarin proficiency level?',
          options: [
            { id: 'Q168P0002o1', label: 'Elementary 满足基础交流' },
            { id: 'Q168P0002o2', label: 'Business Proficiency 商务汉语流利' },
            { id: 'Q168P0002o3', label: 'Native or Biligual 母语或双语' }
          ]
        },
        {
          id: 'Q168P0003',
          type: FormPropertyTypes.Textfield,
          required: true,
          label:
            'ID number (eg. Passport, National ID)',
          options: [
          ]
        },
        {
          id: 'Q168P0004',
          type: FormPropertyTypes.Textfield,
          required: true,
          label:
            'Given Name (Must be consistent with the name on your ID documents)',
          options: [
          ]
        },
        {
          id: 'Q168P0005',
          type: FormPropertyTypes.Textfield,
          required: false,
          label:
            'Given Name in Chinese (If applicable)',
          options: [
          ]
        },
        {
          id: 'Q168P0006',
          type: FormPropertyTypes.Textfield,
          required: true,
          label:
            'Family Name (Must be consistent with the name on your ID documents)',
          options: [
          ]
        },
        {
          id: 'Q168P0007',
          type: FormPropertyTypes.Textfield,
          required: false,
          label:
            'Family Name in Chinese (If applicable)',
          options: [
          ]
        },
        {
          id: 'Q168P0008',
          type: FormPropertyTypes.Date,
          required: true,
          label:
            'Date of birth',
          options: [
          ]
        },
        {
          id: 'Q168P0009',
          type: FormPropertyTypes.Textfield,
          required: false,
          label:
            'Secondary Contact Number',
          options: [
          ]
        },
        {
          id: 'Q168P0010',
          type: FormPropertyTypes.Radio,
          required: true,
          label:
            'Gender',
          options: [
            { id: 'Q168P0010o1', label: 'Prefer not to disclose 不愿意透露' },
            { id: 'Q168P0010o2', label: 'Male 男性' },
            { id: 'Q168P0010o3', label: 'Female 女性' }
          ]
        },
        {
          id: 'Q168P0011',
          type: FormPropertyTypes.Textfield,
          required: true,
          label:
            'Email address',
          options: [
          ]
        }
      ]
    },
    P1: {
      Title: 'Emergency contact',
      Questions:
        [
          {
            id: 'Q168P0101',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Name',
            options: [
            ]
          },
          {
            id: 'Q168P0102',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Relationship',
            options: [
            ]
          },
          {
            id: 'Q168P0103',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Contact number',
            options: [
            ]
          },
          {
            id: 'Q168P0104',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Email address',
            options: [
            ]
          }
        ]
    },
    P2: {
      Title: 'Educational history (Maximum of 5)',
      Questions:
        [
          [
            {
              id: 'Q168P0201',
              type: FormPropertyTypes.Radio,
              required: true,
              label: 'Highest education degree (If other, please specify)',
              options: [
                { id: 'Q168P0201o1', label: 'Bachelor 本科' },
                { id: 'Q168P0201o2', label: 'Master 硕士' },
                { id: 'Q168P0201o3', label: 'PhD 博士' },
                { id: 'Q168P0201o4', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P0201o4_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P0203',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'University or educational institution',
              options: [
              ]
            },
            {
              id: 'Q168P0204',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'From',
              options: [
              ]
            },
            {
              id: 'Q168P0205',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'To',
              options: [
              ]
            },
            {
              id: 'Q168P0206',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'GPA',
              options: [
              ]
            },
            {
              id: 'Q168P0207',
              type: FormPropertyTypes.Select,
              required: true,
              label: 'Major (If other, please specify)',
              options: [
                { id: 'Q168P0207o01', label: 'Accounting 会计' },
                { id: 'Q168P0207o02', label: 'Acturial 精算' },
                { id: 'Q168P0207o03', label: 'Business 商务' },
                { id: 'Q168P0207o04', label: 'Engineering 工程' },
                { id: 'Q168P0207o05', label: 'Law 法律' },
                { id: 'Q168P0207o06', label: 'Mathematics 数学' },
                { id: 'Q168P0207o07', label: 'Science 科学' },
                { id: 'Q168P0207o08', label: 'Technology 技术' },
                { id: 'Q168P0207o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P0207o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P0209',
              type: FormPropertyTypes.Select,
              required: false,
              label: 'Minor (If other, please specify)',
              options: [
                { id: 'Q168P0209o01', label: 'Accounting 会计' },
                { id: 'Q168P0209o02', label: 'Acturial 精算' },
                { id: 'Q168P0209o03', label: 'Business 商务' },
                { id: 'Q168P0209o04', label: 'Engineering 工程' },
                { id: 'Q168P0209o05', label: 'Law 法律' },
                { id: 'Q168P0209o06', label: 'Mathematics 数学' },
                { id: 'Q168P0209o07', label: 'Science 科学' },
                { id: 'Q168P0209o08', label: 'Technology 技术' },
                { id: 'Q168P0209o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P0209o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P02012',
              type: FormPropertyTypes.Radio,
              required: true,
              label: 'Secondary highest education degree (If other, please specify)',
              options: [
                { id: 'Q168P02012o1', label: 'Bachelor 本科' },
                { id: 'Q168P02012o2', label: 'Master 硕士' },
                { id: 'Q168P02012o3', label: 'PhD 博士' },
                { id: 'Q168P02012o4', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02012o4_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02032',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'University or educational institution',
              options: [
              ]
            },
            {
              id: 'Q168P02042',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'From',
              options: [
              ]
            },
            {
              id: 'Q168P02052',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'To',
              options: [
              ]
            },
            {
              id: 'Q168P02062',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'GPA',
              options: [
              ]
            },
            {
              id: 'Q168P02072',
              type: FormPropertyTypes.Select,
              required: true,
              label: 'Major (If other, please specify)',
              options: [
                { id: 'Q168P02072o01', label: 'Accounting 会计' },
                { id: 'Q168P02072o02', label: 'Acturial 精算' },
                { id: 'Q168P02072o03', label: 'Business 商务' },
                { id: 'Q168P02072o04', label: 'Engineering 工程' },
                { id: 'Q168P02072o05', label: 'Law 法律' },
                { id: 'Q168P02072o06', label: 'Mathematics 数学' },
                { id: 'Q168P02072o07', label: 'Science 科学' },
                { id: 'Q168P02072o08', label: 'Technology 技术' },
                { id: 'Q168P02072o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02072o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02092',
              type: FormPropertyTypes.Select,
              required: false,
              label: 'Minor (If other, please specify)',
              options: [
                { id: 'Q168P02092o01', label: 'Accounting 会计' },
                { id: 'Q168P02092o02', label: 'Acturial 精算' },
                { id: 'Q168P02092o03', label: 'Business 商务' },
                { id: 'Q168P02092o04', label: 'Engineering 工程' },
                { id: 'Q168P02092o05', label: 'Law 法律' },
                { id: 'Q168P02092o06', label: 'Mathematics 数学' },
                { id: 'Q168P02092o07', label: 'Science 科学' },
                { id: 'Q168P02092o08', label: 'Technology 技术' },
                { id: 'Q168P02092o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02092o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P02013',
              type: FormPropertyTypes.Radio,
              required: true,
              label: 'Third highest education degree (If other, please specify)',
              options: [
                { id: 'Q168P02013o1', label: 'Bachelor 本科' },
                { id: 'Q168P02013o2', label: 'Master 硕士' },
                { id: 'Q168P02013o3', label: 'PhD 博士' },
                { id: 'Q168P02013o4', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02013o4_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02033',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'University or educational institution',
              options: [
              ]
            },
            {
              id: 'Q168P02043',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'From',
              options: [
              ]
            },
            {
              id: 'Q168P02053',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'To',
              options: [
              ]
            },
            {
              id: 'Q168P02063',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'GPA',
              options: [
              ]
            },
            {
              id: 'Q168P02073',
              type: FormPropertyTypes.Select,
              required: true,
              label: 'Major (If other, please specify)',
              options: [
                { id: 'Q168P02073o01', label: 'Accounting 会计' },
                { id: 'Q168P02073o02', label: 'Acturial 精算' },
                { id: 'Q168P02073o03', label: 'Business 商务' },
                { id: 'Q168P02073o04', label: 'Engineering 工程' },
                { id: 'Q168P02073o05', label: 'Law 法律' },
                { id: 'Q168P02073o06', label: 'Mathematics 数学' },
                { id: 'Q168P02073o07', label: 'Science 科学' },
                { id: 'Q168P02073o08', label: 'Technology 技术' },
                { id: 'Q168P02073o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02073o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02093',
              type: FormPropertyTypes.Select,
              required: false,
              label: 'Minor (If other, please specify)',
              options: [
                { id: 'Q168P02093o01', label: 'Accounting 会计' },
                { id: 'Q168P02093o02', label: 'Acturial 精算' },
                { id: 'Q168P02093o03', label: 'Business 商务' },
                { id: 'Q168P02093o04', label: 'Engineering 工程' },
                { id: 'Q168P02093o05', label: 'Law 法律' },
                { id: 'Q168P02093o06', label: 'Mathematics 数学' },
                { id: 'Q168P02093o07', label: 'Science 科学' },
                { id: 'Q168P02093o08', label: 'Technology 技术' },
                { id: 'Q168P02093o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02093o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P02014',
              type: FormPropertyTypes.Radio,
              required: true,
              label: 'Fourth highest education degree (If other, please specify)',
              options: [
                { id: 'Q168P02014o1', label: 'Bachelor 本科' },
                { id: 'Q168P02014o2', label: 'Master 硕士' },
                { id: 'Q168P02014o3', label: 'PhD 博士' },
                { id: 'Q168P02014o4', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02014o4_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02034',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'University or educational institution',
              options: [
              ]
            },
            {
              id: 'Q168P02044',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'From',
              options: [
              ]
            },
            {
              id: 'Q168P02054',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'To',
              options: [
              ]
            },
            {
              id: 'Q168P02064',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'GPA',
              options: [
              ]
            },
            {
              id: 'Q168P02074',
              type: FormPropertyTypes.Select,
              required: true,
              label: 'Major (If other, please specify)',
              options: [
                { id: 'Q168P02074o01', label: 'Accounting 会计' },
                { id: 'Q168P02074o02', label: 'Acturial 精算' },
                { id: 'Q168P02074o03', label: 'Business 商务' },
                { id: 'Q168P02074o04', label: 'Engineering 工程' },
                { id: 'Q168P02074o05', label: 'Law 法律' },
                { id: 'Q168P02074o06', label: 'Mathematics 数学' },
                { id: 'Q168P02074o07', label: 'Science 科学' },
                { id: 'Q168P02074o08', label: 'Technology 技术' },
                { id: 'Q168P02074o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02074o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02094',
              type: FormPropertyTypes.Select,
              required: false,
              label: 'Minor (If other, please specify)',
              options: [
                { id: 'Q168P02094o01', label: 'Accounting 会计' },
                { id: 'Q168P02094o02', label: 'Acturial 精算' },
                { id: 'Q168P02094o03', label: 'Business 商务' },
                { id: 'Q168P02094o04', label: 'Engineering 工程' },
                { id: 'Q168P02094o05', label: 'Law 法律' },
                { id: 'Q168P02094o06', label: 'Mathematics 数学' },
                { id: 'Q168P02094o07', label: 'Science 科学' },
                { id: 'Q168P02094o08', label: 'Technology 技术' },
                { id: 'Q168P02094o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02094o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P02015',
              type: FormPropertyTypes.Radio,
              required: true,
              label: 'Fifth highest education degree (If other, please specify)',
              options: [
                { id: 'Q168P02015o1', label: 'Bachelor 本科' },
                { id: 'Q168P02015o2', label: 'Master 硕士' },
                { id: 'Q168P02015o3', label: 'PhD 博士' },
                { id: 'Q168P02015o4', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02015o4_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02035',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'University or educational institution',
              options: [
              ]
            },
            {
              id: 'Q168P02045',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'From',
              options: [
              ]
            },
            {
              id: 'Q168P02055',
              type: FormPropertyTypes.Date,
              required: true,
              label: 'To',
              options: [
              ]
            },
            {
              id: 'Q168P02065',
              type: FormPropertyTypes.Textfield,
              required: true,
              label: 'GPA',
              options: [
              ]
            },
            {
              id: 'Q168P02075',
              type: FormPropertyTypes.Select,
              required: true,
              label: 'Major (If other, please specify)',
              options: [
                { id: 'Q168P02075o01', label: 'Accounting 会计' },
                { id: 'Q168P02075o02', label: 'Acturial 精算' },
                { id: 'Q168P02075o03', label: 'Business 商务' },
                { id: 'Q168P02075o04', label: 'Engineering 工程' },
                { id: 'Q168P02075o05', label: 'Law 法律' },
                { id: 'Q168P02075o06', label: 'Mathematics 数学' },
                { id: 'Q168P02075o07', label: 'Science 科学' },
                { id: 'Q168P02075o08', label: 'Technology 技术' },
                { id: 'Q168P02075o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02075o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            },
            {
              id: 'Q168P02095',
              type: FormPropertyTypes.Select,
              required: false,
              label: 'Minor (If other, please specify)',
              options: [
                { id: 'Q168P02095o01', label: 'Accounting 会计' },
                { id: 'Q168P02095o02', label: 'Acturial 精算' },
                { id: 'Q168P02095o03', label: 'Business 商务' },
                { id: 'Q168P02095o04', label: 'Engineering 工程' },
                { id: 'Q168P02095o05', label: 'Law 法律' },
                { id: 'Q168P02095o06', label: 'Mathematics 数学' },
                { id: 'Q168P02095o07', label: 'Science 科学' },
                { id: 'Q168P02095o08', label: 'Technology 技术' },
                { id: 'Q168P02095o09', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P02095o09_other',
              type: FormPropertyTypes.Textfield,
              required: false,
              label: '',
              options: [
              ]
            }
          ]
        ]
    },
    P3: {
      Title: 'Awards and accomplishments (Including scholarships and outstanding accomplishments, maximum 5 to be provided)',
      Questions:
        [
          [
            {
              id: 'Q168P0301',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Name of award',
              options: [
              ]
            },
            {
              id: 'Q168P0302',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Year',
              options: [
              ]
            },
            {
              id: 'Q168P0303',
              type: FormPropertyTypes.Radio,
              required: false,
              label:
                'Level',
              options: [
                { id: 'Q168P0303o1', label: 'National 国家级' },
                { id: 'Q168P0303o2', label: 'Regional 地区级' },
                { id: 'Q168P0303o3', label: 'University 学校级' },
                { id: 'Q168P0303o4', label: 'Department 部门级' }
              ]
            }
          ],
          [
            {
              id: 'Q168P03012',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Name of award',
              options: [
              ]
            },
            {
              id: 'Q168P03022',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Year',
              options: [
              ]
            },
            {
              id: 'Q168P03032',
              type: FormPropertyTypes.Radio,
              required: false,
              label:
                'Level',
              options: [
                { id: 'Q168P03032o1', label: 'National 国家级' },
                { id: 'Q168P03032o2', label: 'Regional 地区级' },
                { id: 'Q168P03032o3', label: 'University 学校级' },
                { id: 'Q168P03032o4', label: 'Department 部门级' }
              ]
            }
          ],
          [
            {
              id: 'Q168P03013',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Name of award',
              options: [
              ]
            },
            {
              id: 'Q168P03023',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Year',
              options: [
              ]
            },
            {
              id: 'Q168P03033',
              type: FormPropertyTypes.Radio,
              required: false,
              label:
                'Level',
              options: [
                { id: 'Q168P03033o1', label: 'National 国家级' },
                { id: 'Q168P03033o2', label: 'Regional 地区级' },
                { id: 'Q168P03033o3', label: 'University 学校级' },
                { id: 'Q168P03033o4', label: 'Department 部门级' }
              ]
            }
          ],
          [
            {
              id: 'Q168P03014',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Name of award',
              options: [
              ]
            },
            {
              id: 'Q168P03024',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Year',
              options: [
              ]
            },
            {
              id: 'Q168P03034',
              type: FormPropertyTypes.Radio,
              required: false,
              label:
                'Level',
              options: [
                { id: 'Q168P03034o1', label: 'National 国家级' },
                { id: 'Q168P03034o2', label: 'Regional 地区级' },
                { id: 'Q168P03034o3', label: 'University 学校级' },
                { id: 'Q168P03034o4', label: 'Department 部门级' }
              ]
            }
          ],
          [
            {
              id: 'Q168P03015',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Name of award',
              options: [
              ]
            },
            {
              id: 'Q168P03025',
              type: FormPropertyTypes.Textfield,
              required: false,
              label:
                'Year',
              options: [
              ]
            },
            {
              id: 'Q168P03035',
              type: FormPropertyTypes.Radio,
              required: false,
              label:
                'Level',
              options: [
                { id: 'Q168P03035o1', label: 'National 国家级' },
                { id: 'Q168P03035o2', label: 'Regional 地区级' },
                { id: 'Q168P03035o3', label: 'University 学校级' },
                { id: 'Q168P03035o4', label: 'Department 部门级' }
              ]
            }
          ]
        ]
    },
    P4: {
      Title: 'Standardized tests',
      Questions:
        [
          [
            {
              id: 'Q168P0400',
              type: FormPropertyTypes.Radio,
              required: true,
              trigPageCheck: true,
              label:
                'Have you taken any standardized tests before?',
              options: [
                { id: 'Q168P0400o1', label: 'Yes 是' },
                { id: 'Q168P0400o2', label: 'No 否' }
              ]
            },
            {
              id: 'Q168P0401',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Please specify the type of tests you have taken',
              options: [
                { id: 'Q168P0401o1', label: 'GMAT' },
                { id: 'Q168P0401o2', label: 'GRE' },
                { id: 'Q168P0401o3', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P0401o3_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P0403',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P04012',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Please specify the type of tests you have taken',
              options: [
                { id: 'Q168P04012o1', label: 'GMAT' },
                { id: 'Q168P04012o2', label: 'GRE' },
                { id: 'Q168P04012o3', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P04012o3_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P04032',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P04013',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Please specify the type of tests you have taken',
              options: [
                { id: 'Q168P04013o1', label: 'GMAT' },
                { id: 'Q168P04013o2', label: 'GRE' },
                { id: 'Q168P04013o3', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P04013o3_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P04033',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P04014',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Please specify the type of tests you have taken',
              options: [
                { id: 'Q168P04014o1', label: 'GMAT' },
                { id: 'Q168P04014o2', label: 'GRE' },
                { id: 'Q168P04014o3', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P04014o3_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P04034',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P04015',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Please specify the type of tests you have taken',
              options: [
                { id: 'Q168P04015o1', label: 'GMAT' },
                { id: 'Q168P04015o2', label: 'GRE' },
                { id: 'Q168P04015o3', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P04015o3_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P04035',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ]
        ]
    },
    P5: {
      Title: 'English skills',
      Questions:
        [
          [
            {
              id: 'Q168P0500',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'English proficiency',
              options: [
                { id: 'Q168P0500o1', label: 'Elementary 满足基础交流' },
                { id: 'Q168P0500o2', label: 'Business Proficiency 商务英语流利' },
                { id: 'Q168P0500o3', label: 'Native or Biligual 母语或双语' }
              ]
            },
            {
              id: 'Q168P05000',
              type: FormPropertyTypes.Radio,
              required: true,
              trigPageCheck: true,
              label:
                'Have you taken any public English examinations before?',
              options: [
                { id: 'Q168P05000o1', label: 'Yes 是' },
                { id: 'Q168P05000o2', label: 'No 否' }
              ]
            },
            {
              id: 'Q168P0501',
              type: FormPropertyTypes.Select,
              required: true,
              label:
                'Please specify the name of Public English Examination',
              options: [
                { id: 'Q168P0501o1', label: 'CET 4 大学英语4级' },
                { id: 'Q168P0501o2', label: 'CET 6 大学英语6级' },
                { id: 'Q168P0501o3', label: 'IETLS 雅思' },
                { id: 'Q168P0501o4', label: 'TOEFL 托福' },
                { id: 'Q168P0501o5', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P0501o5_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P0503',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P05012',
              type: FormPropertyTypes.Select,
              required: true,
              label:
                'Please specify the name of Public English Examination',
              options: [
                { id: 'Q168P05012o1', label: 'CET 4 大学英语4级' },
                { id: 'Q168P05012o2', label: 'CET 6 大学英语6级' },
                { id: 'Q168P05012o3', label: 'IETLS 雅思' },
                { id: 'Q168P05012o4', label: 'TOEFL 托福' },
                { id: 'Q168P05012o5', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P05012o5_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P05032',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P05013',
              type: FormPropertyTypes.Select,
              required: true,
              label:
                'Please specify the name of Public English Examination',
              options: [
                { id: 'Q168P05013o1', label: 'CET 4 大学英语4级' },
                { id: 'Q168P05013o2', label: 'CET 6 大学英语6级' },
                { id: 'Q168P05013o3', label: 'IETLS 雅思' },
                { id: 'Q168P05013o4', label: 'TOEFL 托福' },
                { id: 'Q168P05013o5', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P05013o5_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P05033',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P05014',
              type: FormPropertyTypes.Select,
              required: true,
              label:
                'Please specify the name of Public English Examination',
              options: [
                { id: 'Q168P05014o1', label: 'CET 4 大学英语4级' },
                { id: 'Q168P05014o2', label: 'CET 6 大学英语6级' },
                { id: 'Q168P05014o3', label: 'IETLS 雅思' },
                { id: 'Q168P05014o4', label: 'TOEFL 托福' },
                { id: 'Q168P05014o5', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P05014o5_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P05034',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P05015',
              type: FormPropertyTypes.Select,
              required: true,
              label:
                'Please specify the name of Public English Examination',
              options: [
                { id: 'Q168P05015o1', label: 'CET 4 大学英语4级' },
                { id: 'Q168P05015o2', label: 'CET 6 大学英语6级' },
                { id: 'Q168P05015o3', label: 'IETLS 雅思' },
                { id: 'Q168P05015o4', label: 'TOEFL 托福' },
                { id: 'Q168P05015o5', label: 'Others, please specify 其他，请注明' }
              ]
            },
            {
              id: 'Q168P05015o5_other',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                '',
              options: [
              ]
            },
            {
              id: 'Q168P05035',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Test result',
              options: [
              ]
            }
          ]
        ]
    },
    P6: {
      Title: 'Other language skills',
      Questions:
        [
          {
            id: 'Q168P0601',
            type: FormPropertyTypes.Checkbox,
            required: false,
            label:
              'What other language(s) are you business fluent in',
            options: [
              { id: 'Q168P0601o1', label: 'Chinese, Cantonese 粤语' },
              { id: 'Q168P0601o2', label: 'Chinese, Mandarin 普通话' },
              { id: 'Q168P0601o3', label: 'French 法语' },
              { id: 'Q168P0601o4', label: 'German 德语' },
              { id: 'Q168P0601o5', label: 'Japanese 日语' },
              { id: 'Q168P0601o6', label: 'Korean 韩语' },
              { id: 'Q168P0601o7', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P0601o7_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label:
              '',
            options: [
            ]
          }
        ]
    },
    P7: {
      Title: 'Professional qualifications (Maximum of 5)',
      Questions:
        [
          [
            {
              id: 'Q168P0700',
              type: FormPropertyTypes.Radio,
              required: true,
              trigPageCheck: true,
              label:
                'Do you have any professional qualification?',
              options: [
                { id: 'Q168P0700o1', label: 'Yes 是' },
                { id: 'Q168P0700o2', label: 'No 否' }
              ]
            },
            {
              id: 'Q168P0701',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Type',
              options: [
                { id: 'Q168P0701o1', label: 'ACCA' },
                { id: 'Q168P0701o2', label: 'AICPA' },
                { id: 'Q168P0701o3', label: 'CFA' },
                { id: 'Q168P0701o4', label: 'CICPA' },
                { id: 'Q168P0701o5', label: 'HKICPA' }
              ]
            },
            {
              id: 'Q168P0702',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Status',
              options: [
                { id: 'Q168P0702o1', label: 'Completed 已完成' },
                { id: 'Q168P0702o2', label: 'Partially completed 部分完成' }
              ]
            },
            {
              id: 'Q168P0703',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'How many completed',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P07012',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Type',
              options: [
                { id: 'Q168P07012o1', label: 'ACCA' },
                { id: 'Q168P07012o2', label: 'AICPA' },
                { id: 'Q168P07012o3', label: 'CFA' },
                { id: 'Q168P07012o4', label: 'CICPA' },
                { id: 'Q168P07012o5', label: 'HKICPA' }
              ]
            },
            {
              id: 'Q168P07022',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Status',
              options: [
                { id: 'Q168P07022o1', label: 'Completed 已完成' },
                { id: 'Q168P07022o2', label: 'Partially completed 部分完成' }
              ]
            },
            {
              id: 'Q168P07032',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'How many completed',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P07013',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Type',
              options: [
                { id: 'Q168P07013o1', label: 'ACCA' },
                { id: 'Q168P07013o2', label: 'AICPA' },
                { id: 'Q168P07013o3', label: 'CFA' },
                { id: 'Q168P07013o4', label: 'CICPA' },
                { id: 'Q168P07013o5', label: 'HKICPA' }
              ]
            },
            {
              id: 'Q168P07023',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Status',
              options: [
                { id: 'Q168P07023o1', label: 'Completed 已完成' },
                { id: 'Q168P07023o2', label: 'Partially completed 部分完成' }
              ]
            },
            {
              id: 'Q168P07033',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'How many completed',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P07014',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Type',
              options: [
                { id: 'Q168P07014o1', label: 'ACCA' },
                { id: 'Q168P07014o2', label: 'AICPA' },
                { id: 'Q168P07014o3', label: 'CFA' },
                { id: 'Q168P07014o4', label: 'CICPA' },
                { id: 'Q168P07014o5', label: 'HKICPA' }
              ]
            },
            {
              id: 'Q168P07024',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Status',
              options: [
                { id: 'Q168P07024o1', label: 'Completed 已完成' },
                { id: 'Q168P07024o2', label: 'Partially completed 部分完成' }
              ]
            },
            {
              id: 'Q168P07034',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'How many completed',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P07015',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Type',
              options: [
                { id: 'Q168P07015o1', label: 'ACCA' },
                { id: 'Q168P07015o2', label: 'AICPA' },
                { id: 'Q168P07015o3', label: 'CFA' },
                { id: 'Q168P07015o4', label: 'CICPA' },
                { id: 'Q168P07015o5', label: 'HKICPA' }
              ]
            },
            {
              id: 'Q168P07025',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Status',
              options: [
                { id: 'Q168P07025o1', label: 'Completed 已完成' },
                { id: 'Q168P07025o2', label: 'Partially completed 部分完成' }
              ]
            },
            {
              id: 'Q168P07035',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'How many completed',
              options: [
              ]
            }
          ]
        ]
    },
    P8: {
      Title: 'Work experience (Maximum of 5)',
      Questions:
        [
          [
            {
              id: 'Q168P0800',
              type: FormPropertyTypes.Radio,
              required: true,
              trigPageCheck: true,
              label:
                'Do you have any work experience?',
              options: [
                { id: 'Q168P0800o1', label: 'Yes 是' },
                { id: 'Q168P0800o2', label: 'No 否' }
              ]
            },
            {
              id: 'Q168P0801',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'How many years of work experience do you have?',
              options: [
                { id: 'Q168P0801o1', label: '0-5 Years 0-5年' },
                { id: 'Q168P0801o2', label: '5-10 Years 5-10年' },
                { id: 'Q168P0801o3', label: 'More than 10 Years 10年以上' },
                { id: 'Q168P0801o4', label: 'Not Yet Graduated 尚未毕业' }
              ]
            },
            {
              id: 'Q168P0802',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Employer name',
              options: [
              ]
            },
            {
              id: 'Q168P0803',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'From',
              options: [
              ]
            },
            {
              id: 'Q168P0804',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'To',
              options: [
              ]
            },
            {
              id: 'Q168P0805',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Employment type',
              options: [
                { id: 'Q168P0805o1', label: 'Full Time 全职' },
                { id: 'Q168P0805o2', label: 'Part Time 兼职' },
                { id: 'Q168P0805o3', label: 'Internship 实习' }
              ]
            },
            {
              id: 'Q168P0806',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Department',
              options: [
              ]
            },
            {
              id: 'Q168P0807',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Position or job title',
              options: [
              ]
            },
            {
              id: 'Q168P0808',
              type: FormPropertyTypes.Textarea,
              required: true,
              label:
                'Main responsibility',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P08022',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Employer name',
              options: [
              ]
            },
            {
              id: 'Q168P08032',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'From',
              options: [
              ]
            },
            {
              id: 'Q168P08042',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'To',
              options: [
              ]
            },
            {
              id: 'Q168P08052',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Employment type',
              options: [
                { id: 'Q168P08052o1', label: 'Full Time 全职' },
                { id: 'Q168P08052o2', label: 'Part Time 兼职' },
                { id: 'Q168P08052o3', label: 'Internship 实习' }
              ]
            },
            {
              id: 'Q168P08062',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Department',
              options: [
              ]
            },
            {
              id: 'Q168P08072',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Position or job title',
              options: [
              ]
            },
            {
              id: 'Q168P08082',
              type: FormPropertyTypes.Textarea,
              required: true,
              label:
                'Main responsibility',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P08023',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Employer name',
              options: [
              ]
            },
            {
              id: 'Q168P08033',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'From',
              options: [
              ]
            },
            {
              id: 'Q168P08043',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'To',
              options: [
              ]
            },
            {
              id: 'Q168P08053',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Employment type',
              options: [
                { id: 'Q168P08053o1', label: 'Full Time 全职' },
                { id: 'Q168P08053o2', label: 'Part Time 兼职' },
                { id: 'Q168P08053o3', label: 'Internship 实习' }
              ]
            },
            {
              id: 'Q168P08063',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Department',
              options: [
              ]
            },
            {
              id: 'Q168P08073',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Position or job title',
              options: [
              ]
            },
            {
              id: 'Q168P08083',
              type: FormPropertyTypes.Textarea,
              required: true,
              label:
                'Main responsibility',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P08024',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Employer name',
              options: [
              ]
            },
            {
              id: 'Q168P08034',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'From',
              options: [
              ]
            },
            {
              id: 'Q168P08044',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'To',
              options: [
              ]
            },
            {
              id: 'Q168P08054',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Employment type',
              options: [
                { id: 'Q168P08054o1', label: 'Full Time 全职' },
                { id: 'Q168P08054o2', label: 'Part Time 兼职' },
                { id: 'Q168P08054o3', label: 'Internship 实习' }
              ]
            },
            {
              id: 'Q168P08064',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Department',
              options: [
              ]
            },
            {
              id: 'Q168P08074',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Position or job title',
              options: [
              ]
            },
            {
              id: 'Q168P08084',
              type: FormPropertyTypes.Textarea,
              required: true,
              label:
                'Main responsibility',
              options: [
              ]
            }
          ],
          [
            {
              id: 'Q168P08025',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Employer name',
              options: [
              ]
            },
            {
              id: 'Q168P08035',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'From',
              options: [
              ]
            },
            {
              id: 'Q168P08045',
              type: FormPropertyTypes.Date,
              required: true,
              label:
                'To',
              options: [
              ]
            },
            {
              id: 'Q168P08055',
              type: FormPropertyTypes.Radio,
              required: true,
              label:
                'Employment type',
              options: [
                { id: 'Q168P08055o1', label: 'Full Time 全职' },
                { id: 'Q168P08055o2', label: 'Part Time 兼职' },
                { id: 'Q168P08055o3', label: 'Internship 实习' }
              ]
            },
            {
              id: 'Q168P08065',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Department',
              options: [
              ]
            },
            {
              id: 'Q168P08075',
              type: FormPropertyTypes.Textfield,
              required: true,
              label:
                'Position or job title',
              options: [
              ]
            },
            {
              id: 'Q168P08085',
              type: FormPropertyTypes.Textarea,
              required: true,
              label:
                'Main responsibility',
              options: [
              ]
            }
          ]
        ]
    },
    P9:
    {
      Title: 'Open questions',
      Disc: 'We would like to give you the opportunity to present yourself to us and to provide insight into your experiences, aspirations and thought processes. You can answer in English or Mandarin. It is highly recommended that you develop the answers in word processing software such as Word, and then copy and paste your answers here.',
      Questions:
        [
          {
            id: 'Q168P0901',
            type: FormPropertyTypes.Textarea,
            required: true,
            label:
              'What is the greatest achievement you are most proud of? Alternatively, what do you think has been the biggest challenge in your life so far?',
            options: [
            ]
          },
          {
            id: 'Q168P0902',
            type: FormPropertyTypes.Textarea,
            required: true,
            label:
              'What are your future aspirations?',
            options: [
            ]
          },
          {
            id: 'Q168P0903',
            type: FormPropertyTypes.Textarea,
            required: false,
            label:
              'Why do you want to join this programme at this point of your life? What do you want to get out of it?',
            options: [
            ]
          }
        ]
    },
    P10:
    {
      Title: 'Recommendation',
      Disc: 'Please note: Referrers are required to submit their letters before our application deadline. You are responsible for ensuring that the letters are submitted on time.',
      Questions:
        [
          {
            id: 'Q168P1001',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Referrer name',
            options: [
            ]
          },
          {
            id: 'Q168P1002',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Job title',
            options: [
            ]
          },
          {
            id: 'Q168P1003',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Relationship',
            options: [
            ]
          },
          {
            id: 'Q168P1004',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'How many years have you known the referrer?',
            options: [
            ]
          },
          {
            id: 'Q168P1005',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              'Email address (business email is recommended)',
            options: [
            ]
          }
        ]
    },
    P11:
    {
      Title: 'Attachment',
      Questions:
        [
          {
            id: 'Q168P111',
            type: FormPropertyTypes.File,
            required: true,
            label:
              'Resume',
            options: [
            ]
          },
          {
            id: 'Q168P112',
            type: FormPropertyTypes.File,
            required: true,
            label:
              'Transcript',
            options: [
            ]
          },
          {
            id: 'Q168P113',
            type: FormPropertyTypes.File,
            required: false,
            label:
              'Standardized tests results (If applicable)',
            options: [
            ]
          },
          {
            id: 'Q168P114',
            type: FormPropertyTypes.File,
            required: false,
            label:
              'Awards and accomplishments (If applicable)',
            options: [
            ]
          },
          {
            id: 'Q168P115',
            type: FormPropertyTypes.File,
            required: false,
            label:
              'Professional qualification(s) (If applicable)',
            options: [
            ]
          }
        ]
    },
    P12:
    {
      Title: 'More about you',
      Questions:
        [
          {
            id: 'Q168P1201',
            type: FormPropertyTypes.Select,
            required: true,
            label:
              'From which channel did you learn about this opportunity?',
            options: [
              { id: 'Q168P1201o1', label: 'Family 家庭' },
              { id: 'Q168P1201o2', label: 'Friends 朋友' },
              { id: 'Q168P1201o3', label: 'LinkedIn 领英' },
              { id: 'Q168P1201o4', label: 'On-campus event 校园活动' },
              { id: 'Q168P1201o5', label: 'PwC website/offical social account PwC官方网站和官方社交账户' },
              { id: 'Q168P1201o6', label: 'Wechat 微信' },
              { id: 'Q168P1201o7', label: 'Weibo 微博' },
              { id: 'Q168P1201o8', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P1201o8_other',
            type: FormPropertyTypes.Textfield,
            required: true,
            label:
              '',
            options: [
            ]
          },
          {
            id: 'Q168P1203',
            type: FormPropertyTypes.Radio,
            required: true,
            label:
              'Have you ever attended PwC Superday?',
            options: [
              { id: 'Q168P1203o1', label: 'Yes 是' },
              { id: 'Q168P1203o2', label: 'No 否' }
            ]
          },
          {
            id: 'Q168P1204',
            type: FormPropertyTypes.Radio,
            required: true,
            label:
              'I would like to be considered for merit-based scholarships(Please note that scholarship application process is separate from admission process) ',
            options: [
              { id: 'Q168P1204o1', label: 'Yes 是' },
              { id: 'Q168P1204o2', label: 'No 否' }
            ]
          },
          {
            id: 'Q168P1204o1_other',
            type: FormPropertyTypes.Textarea,
            required: false,
            label:
              'Please state the reasons why you should be awarded the scholarship?',
            options: [

            ]
          },
          {
            id: 'Q168P1206',
            type: FormPropertyTypes.Radio,
            required: true,
            label:
              'I am likely to apply for a student loan',
            options: [
              { id: 'Q168P1206o1', label: 'Yes 是' },
              { id: 'Q168P1206o2', label: 'No 否' }
            ]
          },
          {
            id: 'Q168P1207',
            type: FormPropertyTypes.Select,
            required: true,
            label:
              'First preference, which industries are you most interested in?',
            options: [
              { id: 'Q168P1207o01', label: 'Agriculture 农业' },
              { id: 'Q168P1207o02', label: 'Real estate 房地产' },
              { id: 'Q168P1207o03', label: 'Energy 能源' },
              { id: 'Q168P1207o04', label: 'Financial Service (eg. Accounting, Consulting) 专业服务（如会计、咨询）' },
              { id: 'Q168P1207o05', label: 'Utilities 公用事业' },
              { id: 'Q168P1207o06', label: 'Construction and infrastructure 工程建设' },
              { id: 'Q168P1207o07', label: 'Manufacturing 制造业' },
              { id: 'Q168P1207o08', label: 'Education 教育' },
              { id: 'Q168P1207o09', label: 'Trading 贸易' },
              { id: 'Q168P1207o10', label: 'Pharmaceutical and medical health-care 医疗医药保健' },
              { id: 'Q168P1207o11', label: 'Retail and consumer 零售和消费品' },
              { id: 'Q168P1207o12', label: 'Arts, entertainment or recreation 娱乐艺术' },
              { id: 'Q168P1207o13', label: 'Transportation and logistics 交通与物流' },
              { id: 'Q168P1207o14', label: 'Hospitality, leisure and tourism 旅游休闲' },
              { id: 'Q168P1207o15', label: 'Financial Service 金融服务' },
              { id: 'Q168P1207o16', label: 'Telecoms, social media and technology (TMT) 数字新媒体' },
              { id: 'Q168P1207o17', label: 'Automotive 汽车' },
              { id: 'Q168P1207o18', label: 'NGO 非政府组织' },
              { id: 'Q168P1207o19', label: 'High Tech 高科技' },
              { id: 'Q168P1207o20', label: 'E-commerce 电商' },
              { id: 'Q168P1207o21', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P1207o21_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label:
              '',
            options: [

            ]
          },
          {
            id: 'Q168P1209',
            type: FormPropertyTypes.Select,
            required: true,
            label:
              'Second preference, which industries are you most interested in?',
            options: [
              { id: 'Q168P1209o01', label: 'Agriculture 农业' },
              { id: 'Q168P1209o02', label: 'Real estate 房地产' },
              { id: 'Q168P1209o03', label: 'Energy 能源' },
              { id: 'Q168P1209o04', label: 'Financial Service (eg. Accounting, Consulting) 专业服务（如会计、咨询）' },
              { id: 'Q168P1209o05', label: 'Utilities 公用事业' },
              { id: 'Q168P1209o06', label: 'Construction and infrastructure 工程建设' },
              { id: 'Q168P1209o07', label: 'Manufacturing 制造业' },
              { id: 'Q168P1209o08', label: 'Education 教育' },
              { id: 'Q168P1209o09', label: 'Trading 贸易' },
              { id: 'Q168P1209o10', label: 'Pharmaceutical and medical health-care 医疗医药保健' },
              { id: 'Q168P1209o11', label: 'Retail and consumer 零售和消费品' },
              { id: 'Q168P1209o12', label: 'Arts, entertainment or recreation 娱乐艺术' },
              { id: 'Q168P1209o13', label: 'Transportation and logistics 交通与物流' },
              { id: 'Q168P1209o14', label: 'Hospitality, leisure and tourism 旅游休闲' },
              { id: 'Q168P1209o15', label: 'Financial Service 金融服务' },
              { id: 'Q168P1209o16', label: 'Telecoms, social media and technology (TMT) 数字新媒体' },
              { id: 'Q168P1209o17', label: 'Automotive 汽车' },
              { id: 'Q168P1209o18', label: 'NGO 非政府组织' },
              { id: 'Q168P1209o19', label: 'High Tech 高科技' },
              { id: 'Q168P1209o20', label: 'E-commerce 电商' },
              { id: 'Q168P1209o21', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P1209o21_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label:
              '',
            options: [

            ]
          },
          {
            id: 'Q168P1211',
            type: FormPropertyTypes.Select,
            required: true,
            label:
              'Third preference, which industries are you most interested in?',
            options: [
              { id: 'Q168P1211o01', label: 'Agriculture 农业' },
              { id: 'Q168P1211o02', label: 'Real estate 房地产' },
              { id: 'Q168P1211o03', label: 'Energy 能源' },
              { id: 'Q168P1211o04', label: 'Financial Service (eg. Accounting, Consulting) 专业服务（如会计、咨询）' },
              { id: 'Q168P1211o05', label: 'Utilities 公用事业' },
              { id: 'Q168P1211o06', label: 'Construction and infrastructure 工程建设' },
              { id: 'Q168P1211o07', label: 'Manufacturing 制造业' },
              { id: 'Q168P1211o08', label: 'Education 教育' },
              { id: 'Q168P1211o09', label: 'Trading 贸易' },
              { id: 'Q168P1211o10', label: 'Pharmaceutical and medical health-care 医疗医药保健' },
              { id: 'Q168P1211o11', label: 'Retail and consumer 零售和消费品' },
              { id: 'Q168P1211o12', label: 'Arts, entertainment or recreation 娱乐艺术' },
              { id: 'Q168P1211o13', label: 'Transportation and logistics 交通与物流' },
              { id: 'Q168P1211o14', label: 'Hospitality, leisure and tourism 旅游休闲' },
              { id: 'Q168P1211o15', label: 'Financial Service 金融服务' },
              { id: 'Q168P1211o16', label: 'Telecoms, social media and technology (TMT) 数字新媒体' },
              { id: 'Q168P1211o17', label: 'Automotive 汽车' },
              { id: 'Q168P1211o18', label: 'NGO 非政府组织' },
              { id: 'Q168P1211o19', label: 'High Tech 高科技' },
              { id: 'Q168P1211o20', label: 'E-commerce 电商' },
              { id: 'Q168P1211o21', label: 'Others, please specify 其他，请注明' }
            ]
          },
          {
            id: 'Q168P1211o21_other',
            type: FormPropertyTypes.Textfield,
            required: false,
            label:
              'Others',
            options: [

            ]
          }
        ]
    }
  }
}

export const Options = {
  // 是否
  yesOrNo: [
    { id: 'Q168P0001o1', label: 'Yes 是' },
    { id: 'Q168P0001o2', label: 'No 否' }
  ],
  // 语言级别
  languageLevel: [
    { id: 'Q168P0002o1', label: 'Elementary 满足基础交流' },
    { id: 'Q168P0002o2', label: 'Business Proficiency 商务汉语流利' },
    { id: 'Q168P0002o3', label: 'Native or Biligual 母语或双语' }
  ],
  // 性别
  gender: [
    { id: 'Q168P0010o1', label: 'Prefer not to disclose 不愿意透露' },
    { id: 'Q168P0010o2', label: 'Male 男性' },
    { id: 'Q168P0010o3', label: 'Female 女性' }
  ],
  // 最高学历
  highestEducationDegree: [
    { id: 'Q168P0201o1', label: 'Bachelor 本科' },
    { id: 'Q168P0201o2', label: 'Master 硕士' },
    { id: 'Q168P0201o3', label: 'PhD 博士' },
    { id: 'Q168P0201o4', label: 'Others, please specify 其他，请注明' }
  ],
  // 专业
  major: [
    { id: 'Q168P0207o01', label: 'Accounting 会计' },
    { id: 'Q168P0207o02', label: 'Acturial 精算' },
    { id: 'Q168P0207o03', label: 'Business 商务' },
    { id: 'Q168P0207o04', label: 'Engineering 工程' },
    { id: 'Q168P0207o05', label: 'Law 法律' },
    { id: 'Q168P0207o06', label: 'Mathematics 数学' },
    { id: 'Q168P0207o07', label: 'Science 科学' },
    { id: 'Q168P0207o08', label: 'Technology 技术' },
    { id: 'Q168P0207o09', label: 'Others, please specify 其他，请注明' }
  ],
  // 奖项级别
  awardsLevel: [
    { id: 'Q168P0303o1', label: 'National 国家级' },
    { id: 'Q168P0303o2', label: 'Regional 地区级' },
    { id: 'Q168P0303o3', label: 'University 学校级' },
    { id: 'Q168P0303o4', label: 'Department 部门级' }
  ],
  // 测试类型
  testsType: [
    { id: 'Q168P0401o1', label: 'GMAT' },
    { id: 'Q168P0401o2', label: 'GRE' },
    { id: 'Q168P0401o3', label: 'Others, please specify 其他，请注明' }
  ],
  // 英语考试类型
  publicEnglishExamination: [
    { id: 'Q168P0501o1', label: 'CET 4 大学英语4级' },
    { id: 'Q168P0501o2', label: 'CET 6 大学英语6级' },
    { id: 'Q168P0501o3', label: 'IETLS 雅思' },
    { id: 'Q168P0501o4', label: 'TOEFL 托福' },
    { id: 'Q168P0501o5', label: 'Others, please specify 其他，请注明' }
  ],
  // 语言类型
  language: [
    { id: 'Q168P0601o1', label: 'Chinese, Cantonese 粤语' },
    { id: 'Q168P0601o2', label: 'Chinese, Mandarin 普通话' },
    { id: 'Q168P0601o3', label: 'French 法语' },
    { id: 'Q168P0601o4', label: 'German 德语' },
    { id: 'Q168P0601o5', label: 'Japanese 日语' },
    { id: 'Q168P0601o6', label: 'Korean 韩语' },
    { id: 'Q168P0601o7', label: 'Others, please specify 其他，请注明' }
  ],
  // 资质类型
  qualificationsType: [
    { id: 'Q168P0701o1', label: 'ACCA' },
    { id: 'Q168P0701o2', label: 'AICPA' },
    { id: 'Q168P0701o3', label: 'CFA' },
    { id: 'Q168P0701o4', label: 'CICPA' },
    { id: 'Q168P0701o5', label: 'HKICPA' }
  ],
  // 完成度
  completedStatus: [
    { id: 'Q168P0702o1', label: 'Completed 已完成' },
    { id: 'Q168P0702o2', label: 'Partially completed 部分完成' }
  ],
  yearsOfWork: [
    { id: 'Q168P0801o1', label: '0-5 Years 0-5年' },
    { id: 'Q168P0801o2', label: '5-10 Years 5-10年' },
    { id: 'Q168P0801o3', label: 'More than 10 Years 10年以上' },
    { id: 'Q168P0801o4', label: 'Not Yet Graduated 尚未毕业' }
  ],
  employmentType: [
    { id: 'Q168P0805o1', label: 'Full Time 全职' },
    { id: 'Q168P0805o2', label: 'Part Time 兼职' },
    { id: 'Q168P0805o3', label: 'Internship 实习' }
  ],
  opportunityChannel: [
    { id: 'Q168P1201o1', label: 'Family 家庭' },
    { id: 'Q168P1201o2', label: 'Friends 朋友' },
    { id: 'Q168P1201o3', label: 'LinkedIn 领英' },
    { id: 'Q168P1201o4', label: 'On-campus event 校园活动' },
    { id: 'Q168P1201o5', label: 'PwC website/offical social account PwC官方网站和官方社交账户' },
    { id: 'Q168P1201o6', label: 'Wechat 微信' },
    { id: 'Q168P1201o7', label: 'Weibo 微博' },
    { id: 'Q168P1201o8', label: 'Others, please specify 其他，请注明' }
  ],
  industries: [
    { id: 'Q168P1211o01', label: 'Agriculture 农业' },
    { id: 'Q168P1211o02', label: 'Real estate 房地产' },
    { id: 'Q168P1211o03', label: 'Energy 能源' },
    { id: 'Q168P1211o04', label: 'Financial Service (eg. Accounting, Consulting) 专业服务（如会计、咨询）' },
    { id: 'Q168P1211o05', label: 'Utilities 公用事业' },
    { id: 'Q168P1211o06', label: 'Construction and infrastructure 工程建设' },
    { id: 'Q168P1211o07', label: 'Manufacturing 制造业' },
    { id: 'Q168P1211o08', label: 'Education 教育' },
    { id: 'Q168P1211o09', label: 'Trading 贸易' },
    { id: 'Q168P1211o10', label: 'Pharmaceutical and medical health-care 医疗医药保健' },
    { id: 'Q168P1211o11', label: 'Retail and consumer 零售和消费品' },
    { id: 'Q168P1211o12', label: 'Arts, entertainment or recreation 娱乐艺术' },
    { id: 'Q168P1211o13', label: 'Transportation and logistics 交通与物流' },
    { id: 'Q168P1211o14', label: 'Hospitality, leisure and tourism 旅游休闲' },
    { id: 'Q168P1211o15', label: 'Financial Service 金融服务' },
    { id: 'Q168P1211o16', label: 'Telecoms, social media and technology (TMT) 数字新媒体' },
    { id: 'Q168P1211o17', label: 'Automotive 汽车' },
    { id: 'Q168P1211o18', label: 'NGO 非政府组织' },
    { id: 'Q168P1211o19', label: 'High Tech 高科技' },
    { id: 'Q168P1211o20', label: 'E-commerce 电商' },
    { id: 'Q168P1211o21', label: 'Others, please specify 其他，请注明' }
  ]
}
